<template>
  <UModal
    title="Change to your own logo!"
    :close="{ onClick: () => emit('close', false) }"
    description="You can change the logo on your machine, but it will only be saved in your browser. Also, this feature might be removed."
    @update:open="(o) => !o && emit('close', false)"
  >
    <template #body>
      <div class="max-w-48 mx-auto">
        <UFileUpload v-model="file" accept="image/png,image/jpg" />
      </div>
    </template>
    <template #footer>
      <div class="flex justify-end w-full">
        <UButton class="cursor-pointer" :disabled="!file" @click="onSaveLogo"
          >Save in browser</UButton
        >
      </div>
    </template>
  </UModal>
</template>

<script lang="ts" setup>
const file = ref();
const { $customLogo } = useNuxtApp();

const emit = defineEmits<{
  close: [boolean];
  "update:open": [];
}>();

function onSaveLogo() {
  if (!file.value) return;
  $customLogo.setLogo(file.value);
  emit("close", true);
}
</script>
